import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChatMessage } from '../../../models/chat-message';
import { IvyFaceComponent } from '../../ivy-face/ivy-face.component';
import { ContentService } from '../../../services/content.service';
import { environment } from '../../../../../environments/environment';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'app-content-card',
  standalone: true,
  imports: [
    IvyFaceComponent,
    NgClass,
    NgIf
  ],
  templateUrl: './content-card.component.html',
  styleUrl: './content-card.component.scss'
})
export class ContentCardComponent implements OnInit {
  get data(): ChatMessage {
    return this._data;
  }

  @Input()
  set data(value: ChatMessage) {
    this._data = value;
  }
  private _data: ChatMessage;

  showLoader: boolean = true;

  @Output()
  showContent: EventEmitter<{url: string, image?: string}> = new EventEmitter<any>;

  @Output()
  showMore: EventEmitter<any> = new EventEmitter<any>;

  thumbPath: string = environment.cdnPath + '/' + environment.media.images + '/4x5/m/';

  contentItems: any[] = [];

  constructor(public contentService: ContentService) {}

  showMoreContent() {
    this.showMore.emit();
  }

  async ngOnInit() {
    if (this.contentService.contentStore == undefined) {
      await this.contentService.loadInitialContent();
    }
   
    this.generateItems();
  }

  generateItems() {
   for (let option of this.data.answer.options) {
      let action = option.action.split("#");
      if (action.length > 1) {
        let id = action[1];
        let item = this.contentService.getById(id);
        if (item != null && item != undefined) {
          this.contentItems.push(item);
        }
      }
    }

    this.showLoader = false;
  }

  onContentItemClick(content: any) {
    if (content.media_type == 'audio') {
      let url = content.audio;
      let image = this.constructFileImage(content);
       this.showContent.emit({url: url, image: image});
    } else if (content.media_type == 'video') {
      let url = content.video;
      let constructedUrl = this.constructUrl(url);
      this.showContent.emit({url: constructedUrl, image: null});
    } else if (content.url) {
      this.showContent.emit({url: content.url, image: null});
    }
  }

  constructUrl(fileName: string): string {
    return environment.cdnPath + '/' + environment.media.video.ratio16x9 + '/' + fileName.split('.')[0] + '/index.m3u8';
  }

  constructFileImage(content: any): string {
    return environment.cdnPath + '/' + environment.media.images + '/16x9/l/' + content.image;
  }

  toMinutes(value: number | string | null | undefined): string {
    if (value == null) {
      return '1 min';
    }

    if (typeof value === 'string') {
      const parsed = parseInt(value, 10);

      if (!isNaN(parsed)) {
        const mins = Math.ceil(parsed / 60);
        return `${mins} min`;
      }

      if (/\d/.test(value)) {
        return value;
      }

      return '1 min';
    }

    const mins = Math.ceil(value / 60);
    if (isNaN(mins)) {
      return '1 min';
    }

    return `${mins} min`;
  }


  capitalizeFirstLetter(str: string | null | undefined): string {
    if (!str) {
      return '';
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}


